import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IPublishedConnectionColumn } from '../../../publishedConnectionTable/serverApi/types/IPublishedConnectionTable';

export interface IGetPublishedConnectionColumnsParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionColumnsResult extends IGetItemsResult {
  publishedConnectionColumns?: IPublishedConnectionColumn[];
}

export class GetPublishedConnectionColumnsRequest extends Request<IGetPublishedConnectionColumnsParams, IGetPublishedConnectionColumnsResult> {
  constructor(params: IGetPublishedConnectionColumnsParams) {
    super('getPublishedConnectionColumns', params);
  }
}
